<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>活動狀態</p>
      </div>
      <el-steps style="padding: 0 0.5rem;" :active='status-1'>
        <el-step title="未開始階段"></el-step>
        <el-step title="登記階段"></el-step>
        <el-step title="抽籤階段"></el-step>
        <el-step title="確認階段"></el-step>
      </el-steps>

      <el-form class="editStatusForm">
        <el-form-item v-if="status === 3 && type === 'ff'" label='支付結果:' class="editStatusItem">
          <input maxlength="10" disabled class="payResult" type="text" v-model="statusForm.payResult">
        </el-form-item>
        <el-form-item v-if="status === 1" label="開放報名時間:" class="editStatusItem">
          <el-date-picker
            v-model="statusForm.openTime"
            type="datetime"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="status === 1 || status === 2" label="結束報名時間:" class="editStatusItem">
          <el-date-picker
            v-model="statusForm.endTime"
            type="datetime"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="status === 3 && type === 'ff'" label="支付結束時間:" class="editStatusItem">
          <el-date-picker
            v-model="statusForm.payEndTime"
            type="datetime"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="status === 2 || status === 3 || status === 4" label="下載登記列表:" class="editStatusItem">
          <input style="cursor:pointer" placeholder="點擊下載excel模板" @click="downLoadExcel()"
                 class="el-input__inner downloadTableBtn">
        </el-form-item>
        <el-form-item v-if="status === 3 || status === 4" label="上傳抽取資料:" class="editStatusItem">
          <el-upload class="downloadTableBtn"
                     name='file'
                     ref="excelUpload"
                     :accept="'.xlsx,.xls'"
                     :action=this.$GLOBAL.excelpostUrl
                     :headers="{'Authorization': this.$cookie.get('auth')}"
                     :data="{'applyId':this.id}"
                     :with-credentials="true"
                     :before-upload="beforeExcelUpload"
                     :on-remove="handleRemove"
                     :on-success='successExcel'
                     :on-error='errorExcel'
                     :show-file-list=true
                     :multiple="false"
                     :file-list="fileList"
                     :on-change="fileChange"
                     :on-exceed="handleExceed"
                     :limit="1"
                     :auto-upload="false">
            <span class="uploadSpan">請選擇上傳文件</span>
          </el-upload>
        </el-form-item>
      </el-form>

      <div class="bottomBtn" style="padding:0.3rem 0;">
        <div class="btn" @click="submitStatus()">確認提交</div>
        <div v-if="status === 3" class="btn" @click="nextBtn()">下一步</div>
      </div>

    </div>

    <div v-if="fileFlag" class="fileTips">
      <div v-if="fileSuccess" class="successTips tips">資料匹配成功</div>
      <div v-if="fileError" class="errorTips tips">資料匹配錯誤</div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
    <DiaMess v-if="progressMessVisible" style="background-color:rgba(255,255,255,0)"></DiaMess>
    <div v-if="progressVisible" class="progressStyle">
      <el-progress :percentage="progress" type="circle" :width="70"></el-progress>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data() {
    return {
      navBlock: '活動  /  活動列表',
      navtitle: '修改狀態',
      id: this.$route.query.id,
      type: this.$route.query.type,
      status: Number(this.$route.query.status),
      applyName: this.$route.query.applyName,
      statusForm: {
        payResult: '0/0',
        openTime: '',
        endTime: '',
        payEndTime: ''
      },
      fileList: [],
      fileFlag: false,
      fileSuccess: false,
      fileError: false,
      ffFileFlag: false,
      payFlag: false,
      dialogVisible: false,
      progress: 0,
      progressVisible: false,
      timer: '',
      progressMessVisible: false,
      hasSubmit: false
    }
  },
  created() {
    this.getInitState();
  },
  destroyed() {
    localStorage.removeItem('uploaded');
    this.$message.closeAll();
  },
  methods: {
    // 获取活动状态信息
    getInitState() {
      if (this.status === 1) {
        // 未开始阶段
        this.statusForm.openTime = this.$getTime(Number(this.$route.query.startTime));
        this.statusForm.endTime = this.$getTime(Number(this.$route.query.endTime));
      } else if (this.status === 2) {
        // 登记阶段
        this.statusForm.endTime = this.$getTime(Number(this.$route.query.endTime));
      } else if (this.status === 3) {
        // 抽取阶段，获取支付(或抽签)结果
        this.$get(`/request/apply/getTotalNum/${this.id}`, this.$GLOBAL.jsonConfig)
          .then((res) => {
            if (res.code === '00000') {
              if (this.type === 'ff') {
                // this.statusForm.payEndTime = this.$getTime(Number(this.$route.query.endTime))
                this.statusForm.payResult = res.data.payNum + '/' + res.data.totalNum;
              }
              ;
              if (res.data.payNum === res.data.totalNum) {
                this.payFlag = true;
              }
              ;
            } else {
              this.$propMessage(res.message, 'error');
            }
            ;
          });
      }
    },
    //上传excel之前回调函数
    beforeExcelUpload(file) {
      let _this = this;
      if (file === '') {
        _this.dialogVisible = true;
        _this.$propMessage('請選擇需要導入的Excel文件！', 'error', function () {
          _this.dialogVisible = false;
          _this.progressVisible = false;
          _this.progress = 0;
          _this.progressMessVisible = false;
        });
        return false;
      }
      ;
      let result = _this.$checkData(file.name);
      if (result === false) {
        _this.dialogVisible = true;
        _this.$propMessage('請選擇需要導入的Excel文件！', 'error', function () {
          _this.dialogVisible = false;
          _this.progressVisible = false;
          _this.progress = 0;
          _this.progressMessVisible = false;
        });
        return false;
      }
      ;
    },
    // 上传excel超过限制回调函数
    handleExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage('最多上傳1個文件！', 'error', function () {
        _this.dialogVisible = false;
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      localStorage.removeItem('uploaded');
      this.hasSubmit = false
    },
    //excel上传成功回调函数
    successExcel(res, file, fileList) {
      let _this = this;
      if (res.code === '00000') {
        _this.uploadFlag = true;
        _this.fileFlag = true;
        _this.fileSuccess = true;
        setTimeout(function () {
          // 若为抽签阶段，资料上传成功以后，调用活动人数接口，判断名额是否满额，是否可以点击下一步
          localStorage.setItem('uploaded', 'uploaded');
          if (_this.status === 3) {
            _this.getInitState();
            if (_this.type === 'ff') {
              _this.$router.push('/activityList');
            }
          }
          _this.fileFlag = false;
          _this.fileSuccess = false;
        }, 2000)
        _this.progress = 100
        _this.hasSubmit = true
        setTimeout(function () {
          _this.progressVisible = false
          _this.progressMessVisible = false
        }, 1000)
        clearInterval(_this.timer)
      } else {
        _this.fileFlag = true;
        _this.fileError = true;
        _this.ffFileFlag = true;
        _this.dialogVisible = true;
        _this.progressVisible = false;
        _this.progress = 0;
        _this.progressMessVisible = false;
        clearInterval(_this.timer)
        _this.$propMessage(res.message + ',請重新上傳', 'error', function () {
          _this.dialogVisible = false;
          localStorage.setItem('uploaded', '');
        });
        setTimeout(function () {
          _this.fileList = [];
          _this.fileFlag = false;
          _this.fileError = false;
          _this.ffFileFlag = false;
        }, 2000)
      }
    },
    //excel上传失败回调函数
    errorExcel(err, file, fileList) {
      this.uploadFlag = false;
      this.fileFlag = true;
      this.fileError = true;
      this.progressVisible = false;
      this.progress = 0;
      this.progressMessVisible = false;
      clearInterval(this.timer)
      setTimeout(function () {
        this.fileFlag = false;
        this.fileError = false;
      }, 2000);
    },
    //下载excel
    downLoadExcel() {
      let date = new Date()
      if (this.status === 4) {
        // 确认阶段下載excel
        let url = `/request/apply/exportConfirmExcel/${this.id}/${this.type}`
        this.$exportExcel(url, 'GET', {}, this.applyName + '名单' + this.$formatDate(date).substring(0, 10));
        // window.open(this.$GLOBAL.postUrl + '/request/apply/exportConfirmExcel/' + this.id + '/' + this.type)
      } else {
        // 其他阶段
        let url = `/request/apply/exportExcel/${this.id}/${this.type}`
        this.$exportExcel(url, 'GET', {}, this.applyName + '名单' + this.$formatDate(date).substring(0, 10));
        // window.open(this.$GLOBAL.postUrl+'/request/apply/exportExcel/'+this.id+'/'+this.type);
      }
      ;
    },
    // 改变状态
    changeStatus(param) {
      this.$post('/request/apply/updatePeriod', param, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            this.$router.push('/editStatus?id=' + this.id + '&applyName=' + this.applyName + '&type=' + this.type + '&status=' + Number(this.status + 1));
            this.status = this.status + 1;
            this.hasSubmit = false
            if (this.status === 3) {
              this.getInitState();
            }
            ;
            this.statusForm = {
              payResult: '',
              openTime: '',
              endTime: '',
              payEndTime: ''
            };
            this.fileList = [];
          } else {
            this.$router.push('/activityList');
            // 如果不能进入下一阶段则按兵不动
          }
        })
    },
    //下一步
    nextBtn() {
      let _this = this;
      let uploaded = localStorage.getItem('uploaded');
      console.log(uploaded)

      let changeParam = {
        applyId: _this.id
      };
      if (_this.payFlag) {
        _this.$confirm('是否確定已經上傳過抽取資料，並進入下一步?', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
          closeOnClickModal: false
        }).then(() => {
          _this.changeStatus(changeParam);
        }).catch(() => {
        });
      } else {
        // let words = '抽籤';
        // if(this.type === 'ff') {
        //   words = '支付';
        // }
        // this.$Mint.Toast(words + '人數未達標，不可以到達下一步~');
        if (_this.type === 'ff') {
          _this.dialogVisible = true;
          _this.$propMessage('支付人數未達標，不可以到達下一步', 'error', function () {
            _this.dialogVisible = false;
          });
        } else {
          if (uploaded === 'before-upload') {
            _this.dialogVisible = true;
            _this.$propMessage('請先點擊確認提交按鈕', 'error', function () {
              _this.dialogVisible = false;
            });
            return false
          }
          if (uploaded === 'uploading') {
            _this.dialogVisible = true;
            _this.$propMessage('正在修改抽選結果...', 'error', function () {
              _this.dialogVisible = false;
            });
            return false
          }
          if (uploaded !== 'uploaded') {
            _this.dialogVisible = true;
            _this.$propMessage('還沒有修改或上傳需要提交的內容', 'error', function () {
              _this.dialogVisible = false;
            });
            return false
          }
          _this.$confirm('是否確定已經上傳過抽取資料，並進入下一步?', '提示信息', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            center: true,
            closeOnClickModal: false
          }).then(() => {
            _this.changeStatus(changeParam);
          }).catch(() => {
          });
          // if(localStorage.getItem('uploaded') === 'true') {
          //   // 上传过抽取资料
          //   this.changeStatus(changeParam);
          //   localStorage.removeItem('uploaded');
          // } else {
          //   // 未上传过抽取资料
          //   this.$Mint.Toast('請上傳抽取資料');

          // }

        }
      }
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
      localStorage.setItem('uploaded', 'before-upload');
    },
    // 提交修改状态
    submitStatus() {
      let _this = this;
      /*********未开始阶段*********/
      if (_this.status === 1) {

        let timeFormat = this.$compareTime(_this.statusForm.openTime, new Date());
        if (_this.statusForm.openTime === '' || timeFormat === false) {
          _this.dialogVisible = true;
          _this.$propMessage('開始報名時間不能為空，且只能設置未來時間', 'error', function () {
            _this.dialogVisible = false;
          });
          return false;
        }
        ;

        let endtimeFormat = this.$compareTime(_this.statusForm.endTime, _this.statusForm.openTime);
        if (_this.statusForm.openTime === '' || _this.statusForm.endTime === null || endtimeFormat === false) {
          _this.dialogVisible = true;
          _this.$propMessage('結束報名時間不能為空，且只能晚於開始報名時間', 'error', function () {
            _this.dialogVisible = false;
          });
          return false;
        }
        ;
        let param = {
          applyId: _this.id,
          startTime: typeof _this.statusForm.openTime === 'string' ? _this.statusForm.openTime : _this.$formatDate(_this.statusForm.openTime),
          endTime: typeof _this.statusForm.endTime === 'string' ? _this.statusForm.endTime : _this.$formatDate(_this.statusForm.endTime)
        };
        _this.$post('/request/apply/updateApplyTime', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('修改成功', 'success',
                function () {
                  _this.dialogVisible = false;
                  _this.$router.push('/activityList');
                });
            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
          });
      } else if (_this.status === 2) {
        /*********登记阶段*********/
        let param = {
          endTime: typeof _this.statusForm.endTime === 'string' ? _this.statusForm.endTime : _this.$formatDate(_this.statusForm.endTime),
          applyId: _this.id
        };
        _this.$post('/request/apply/updateApplyEndTime', param, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === '00000') {
              _this.$propMessage('結束報名時間修改成功', 'success',
                function () {
                  _this.dialogVisible = false;
                  _this.$router.push('/activityList');
                });

            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
            ;
          });
      } else if (_this.status === 3) {
        /*********抽签阶段*********/
        if (_this.type === 'ff') {
          // 付费活动，提交上传资料和支付结束时间修改
          if (_this.fileList.length === 0 && _this.statusForm.payEndTime === '') {
            localStorage.setItem('uploaded', '');
            _this.dialogVisible = true;
            _this.$propMessage('還沒有修改或上傳需要提交的內容', 'error', function () {
              _this.dialogVisible = false;
            });
            return false;
          }
          ;
          // 修改支付结束时间
          let payEndTimeFormat = _this.$compareTime(_this.statusForm.payEndTime, new Date());
          if (payEndTimeFormat === false) {
            _this.dialogVisible = true;
            _this.$propMessage('支付結束時間不能為空，且只能設置未來時間', 'error', function () {
              _this.dialogVisible = false;
            });
            return false;
          }
          ;
          let param = {
            applyId: _this.id,
            endTime: typeof _this.statusForm.payEndTime === 'string' ? _this.statusForm.payEndTime : _this.$formatDate(_this.statusForm.payEndTime)
          };
          _this.$post('/request/apply/updateAayEndTime', param, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code === '00000') {
                localStorage.setItem('uploaded', 'uploading');
                _this.$refs.excelUpload.submit(); // 手动上传
                _this.$propMessage('支付結束時間修改成功', 'success',
                  function () {
                    _this.dialogVisible = false;
                  });
              } else {
                _this.$propMessage(res.message, 'error',
                  function () {
                    _this.dialogVisible = false;
                  });
              }
              ;
            });
          // 上传抽取资料
        } else {
          //普通活动，提交上传资料
          if (_this.fileList.length === 0) {
            localStorage.setItem('uploaded', '');
            _this.dialogVisible = true;
            _this.$propMessage('還沒有選擇需要上傳的文件', 'error', function () {
              _this.dialogVisible = false;
            });
          } else {
            if (this.hasSubmit) {
              _this.dialogVisible = true;
              _this.$propMessage('不可重複提交文件', 'error', function () {
                _this.dialogVisible = false;
              });
              return
            }
            localStorage.setItem('uploaded', 'uploading');
            _this.$refs.excelUpload.submit(); // 手动上传
            _this.progress = 0
            _this.progressVisible = true
            _this.progressMessVisible = true
            _this.timer = setInterval(function () {
              if (_this.progress >= 95) {
                _this.progress = 99
              } else {
                _this.progress += 5
              }
            }, 1000)

          }
          ;
        }
        ;
      } else if (_this.status === 4) {
        /*********确认阶段*********/
        // 提交上传抽取资料
        if (_this.fileList.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage('還沒有選擇需要上傳的文件', 'error', function () {
            _this.dialogVisible = false;
          });
        } else {
          if (this.hasSubmit) {
            _this.dialogVisible = true;
            _this.$propMessage('不可重複提交文件', 'error', function () {
              _this.dialogVisible = false;
            });
            return
          }
          _this.$refs.excelUpload.submit(); // 手动上传
          _this.progress = 0
          _this.progressVisible = true
          _this.progressMessVisible = true
          _this.timer = setInterval(function () {
            if (_this.progress >= 95) {
              _this.progress = 99
            } else {
              _this.progress += 5
            }
          }, 1000)
        }
        ;
      }
      ;
    }
  },
  components: {
    NavBar,
    DiaMess,

  }
};
</script>
<style lang="less" scoped>
.contentDetails {
  position: relative;

  .detailsContent {
    .editStatusForm {
      margin-top: .5rem;

      .editStatusItem {
        display: flex;
        justify-content: center;

        .downloadTableBtn {
          line-height: 40px;
          border: 1px solid #DCDFE6;
          background: #fff;
          border-radius: 0.04rem;
          @media screen and (max-width: 768px) {
            width: 3.8rem;
          }
          @media screen and (min-width: 769px) {
            width: 2rem;
          }
        }

        .uploadSpan {
          display: inline-block;
          width: 100%;
          color: #C0C4CC;
          @media screen and (max-width: 768px) {
            padding-left: 0.28rem;
          }
          @media screen and (min-width: 769px) {
            padding-left: 0.1rem;
          }
        }
      }
    }
  }

  .fileTips {
    width: 100%;
    height: 0.2rem;
    position: absolute;
    top: 0.8rem;
    left: 0;

    .tips {
      width: 100%;
      height: 100%;
      line-height: 0.2rem;
      color: #fff;
      text-align: center;
      font-size: 0.14rem;
    }

    .successTips {
      background: #AE9EC2;
    }

    .errorTips {
      background: #D28383;
    }
  }

  .progressStyle {
    background-color: #7f7f7f;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: 120px;
    display: flex;
    padding-left: 25px;
    align-items: center;
    border-radius: 12px
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/editStatus.vue